<template>
  <div class="flex flex-col items-end">
    <div class="grid grid-cols-10 gap-8 w-full mb-4">
      <div class="col-span-10">
        <what-expect-card :loading="isSavingData" @reflectionChanged="update"></what-expect-card>
      </div>
    </div>
    <!-- <div class="flex items-center">
            <button
                type="button"
                @click="saveReflection"
                class="
                    relative
                    px-4
                    py-1.5
                    border border-gray-300
                    rounded-md
                    text-xs
                    font-medium
                    text-gray-700
                    bg-white
                    hover:bg-gray-50
                    focus:outline-none
                ">
                <span
                    v-if="loading"
                    class="absolute left-0 top-0 bg-opacity-80
                     bg-gray-50 items-center justify-center flex w-full h-full">
                      <div class="w-5 h-5 border-vice-teal-500 border-2
                      rounded-full border-t-0 animate-spin"></div>
                </span>
                Save & continue
            </button>
        </div> -->
  </div>
</template>

<script>
import axios from 'axios';
import WhatExpectCard from './Reflection/WhatExpectCard.vue';

export default {
  name: 'PersonalLearningGoals',
  emits: ['learningGoalsAdded'],
  components: {
    WhatExpectCard,
  },
  data() {
    return {
      isSavingData: false,
    };
  },
  methods: {
    update(data) {
      this.$inertia.reload({ only: ['session'] });
      this.isSavingData = true;
      const vm = this;
      axios.post(route('reflection.update'), data).then((response) => {
        this.isSavingData = false;
        vm.$emit('learningGoalsAdded', data.value);
        return response.data;
      });
    },
  },
};
</script>

<style scoped></style>
